import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { getGlobal, isSwitchOn } from 'helpers/globalsAndSwitches/globals';
const FeatureSwitchesContext = createContext(undefined);
export function FeatureSwitchesProvider({ children }) {
    const value = useMemo(() => {
        const featureSwitches = getGlobal('settings.switches.featureSwitches') ??
            {};
        return Object.fromEntries(Object.keys(featureSwitches).map((flag) => [
            flag,
            isSwitchOn(`featureSwitches.${flag}`),
        ]));
    }, []);
    return (_jsx(FeatureSwitchesContext.Provider, { value: value, children: children }));
}
export function useFeatureSwitches() {
    const context = useContext(FeatureSwitchesContext);
    if (!context) {
        throw new Error('useFeatureSwitches must be used within a FeatureSwitchesProvider');
    }
    return context;
}
